export const MONITORING_ARRIVAL_HISTORY_DETAIL = {
  STATUS_GOING: 'O responsável comunicou que está a caminho da escola.',
  STATUS_ARRIVED: 'O responsável comunicou que já chegou na portaria.',
  STATUS_RELEASED: 'O aluno foi liberado pela escola.',
  STATUS_CANCELED: 'O responsável cancelou a solicitação.',
  USER_MESSAGE: 'Detalhes do ocorrido: ',
}

export const MONITORING_ARRIVAL_CURRENT_DETAIL = {
  STATUS_GOING: 'Aguardando o responsável indicar que já chegou.',
  STATUS_ARRIVED: 'O responsável está aguardando a liberação do aluno por parte da escola.',
  STATUS_RELEASED: 'O aluno foi liberado pela escola.',
  STATUS_CANCELED: 'O responsável cancelou a solicitação.',
  USER_MESSAGE: 'Detalhes do ocorrido: ',
}

export const AUTHORIZED_USER = {
  STATUS_ARRIVED: 'Aguardando a liberação do aluno por parte da escola.',
  PERMANENT: 'O responsável enviou para a escola os dados relacionados a autorização permanente.',
  TEMPORARY: 'O responsável enviou para a escola os dados relacionados a autorização temporária.'
}
